// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Documentos_BuscareciboResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaRecibo /documentos/buscaRecibo
 * Proxy to html2pdf-service busca endpoint for receipt documents.
 *
 * Each item is the shape of html2pdf-service's `document.Document` GORM
 * model serialised as JSON — see Documentos_BuscareciboRow for the field
 * docs and source pointers.
 */
import type { Documentos_BuscareciboRow } from './Documentos_BuscareciboRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Documentos_BuscareciboResponseDados = Documentos_BuscareciboRow[];

export type Documentos_BuscareciboResponse = ApiResponse<Documentos_BuscareciboResponseDados>;

registerResponseContract('Documentos_BuscareciboResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'number',  required: false },
      CreatedAt: { type: 'string',  required: false },
      UpdatedAt: { type: 'string',  required: false },
      DeletedAt: { type: 'string',  required: false },
      Type:      { type: 'string',  required: false },
      Owner:     { type: 'string',  required: false },
      OwnerID:   { type: 'number',  required: false },
      Src:       { type: 'string',  required: false },
    },
  },
})
